export default __webpack_public_path__ + "static/media/dutgo-screenshot-02.af45a692.png";